import { getEventsLoadedStore, EventsLoadedData } from '../store/store';
import { LoadState } from '../store/schema/LoadState';
import { DateRange } from 'owa-datetime-utils';
import { getEventsReader } from './calendarEventsLockedStoreSelectors';
import { EventsCacheLockId } from 'owa-calendar-events-store';
import { CalendarEvent } from 'owa-calendar-types';
import { CalendarCacheScenarioId } from 'owa-calendar-cache';

export function getEventLockCacheId(scenarioId: CalendarCacheScenarioId): EventsCacheLockId {
    return getScenarioData(scenarioId).eventsCacheLockId;
}

/**
 * Returns the LoadState of events.
 *
 * @param scenarioId - The scenarioId to get the LoadState for
 * @returns The LoadState of the events.
 */
export function getLoadState(scenarioId: CalendarCacheScenarioId): LoadState {
    if (!getEventsLoadedStore().scenarios.has(scenarioId)) {
        return 'DoesNotExist';
    }

    return getScenarioData(scenarioId).loadState;
}

export function getLoadedDateRange(scenarioId: CalendarCacheScenarioId): DateRange {
    return getScenarioData(scenarioId).loadedDateRange;
}

export function getLoadedFolderIds(scenarioId: CalendarCacheScenarioId): string[] {
    return getScenarioData(scenarioId).loadedFolderIds;
}

export function getScenarioData(scenarioId: CalendarCacheScenarioId): EventsLoadedData {
    const scenarioData = getEventsLoadedStore().scenarios.get(scenarioId);
    if (!scenarioData) {
        throw new Error(
            'getScenarioData should not be called until the calendar events loader scenario is initialized'
        );
    }
    return scenarioData;
}

export function isInitializingCalendarEventsLoader(scenarioId: CalendarCacheScenarioId): boolean {
    return getScenarioData(scenarioId).isInitializingCalendarEventsLoader;
}

export function getEvents(
    scenarioId: CalendarCacheScenarioId,
    dateRange?: DateRange
): CalendarEvent[] {
    const eventsDateRange = dateRange ? dateRange : getLoadedDateRange(scenarioId);
    const folderIds = getLoadedFolderIds(scenarioId);
    const lockId = getEventLockCacheId(scenarioId);
    return folderIds ? getEventsReader(lockId).getOrderedEvents(folderIds, eventsDateRange) : [];
}
